import React, { useState, useEffect, Fragment } from "react";
import { Row, Col, CardBody, Card, Table } from "reactstrap";
import i18n from "../../../i18n";
import AlertError from "../../../components/Alerts/AlertError";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { postServicesAssignAdmin } from "../../../helpers/api_rombo_helper";
import Paginations from "../../../components/Common/Pagination";
import Spinners from "../../../components/Common/Spinner";
import { map } from "lodash";
import ModalAssign from "./ModalAssign";
import { useNavigate } from "react-router-dom";

const Step1 = ({ token, services, setServices, setServicesError, infoUser }) => {

  const dispatch = useDispatch();
  const history = useNavigate();

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertHeader, setErrorAlertHeader] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [servicesSuccess, setServicesSuccess] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(7);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = services.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(services.length / recordsPerPage);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [assignedServices, setAssignedServices] = useState([]);
  const [allAssigned, setAllAssigned] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handlePlateClick = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const onClickFinish = () => {
    localStorage.setItem("notify", "true");
    localStorage.setItem("headerText", i18n.t("ServiceAlertSuccessHeader"));
    localStorage.setItem("bodyText", i18n.t("ServiceAlertSuccessBody"));
  
    if (infoUser?.is_staff) {
      history("/services/general");
    } else {
      history("/services/assignment");
    }
  };

  useEffect(() => {
    const onServices = JSON.parse(localStorage.getItem("services"));
    onServices.sort((a, b) => a.code.localeCompare(b.code));
    setServices(onServices);
  }, [dispatch]);

  useEffect(() => {
    let flag = false;
    services.forEach((item) => (item.subDriver ? null : (flag = true)));
    setServicesSuccess(flag);

    let allSuccess = services.every(
      (item) => item.textContent !== "No asignado" && item.textContent !== undefined
    );
    setAllAssigned(allSuccess);
  }, [services]);

  const onClickNextStep = () => {
    const body = {
      assigns: services
        .filter(
          (item) =>
            item.subDriver !== undefined &&
            item.subDriver !== null &&
            item.plate !== undefined &&
            item.plate !== null &&
            !assignedServices.includes(item.code)
        )
        .map((item) => ({
          sub: item.subDriver,
          plate: item.plate,
          code: item.code,
        })),
    };

    postServicesAssignAdmin(token, body)
      .then((resp) => {
        let arr = [];
        let hasErrors = false;

        services.forEach((item) => {
          const itemResp = resp.assigns.find((e) => e.code === item.code);
          if (itemResp) {
            if (itemResp.status === "SUCCESSFUL") {
              item.disabled = true;
              item.className = "bg-green text-white rounded-2 text-center p-1 fs-10";
              item.textContent = i18n.t("Assigned");
              setAssignedServices((prev) => [...prev, item.code]);
            } else {
              hasErrors = true;
              setServicesError(true);
              item.disabled = false;
              item.className = "bg-red text-white rounded-2 text-center p-1 fs-10";
              item.textContent = i18n.t("Unassigned");
              
              if (itemResp.reason === "Trip scheduled conflict") {
                setErrorAlertHeader(i18n.t("AssignAlertError"));
                setErrorAlertMessage(i18n.t("OperatorAlreadyAssigned"));
              } else {
                setErrorAlertHeader(i18n.t("ServiceAlertError"));
                setErrorAlertMessage(i18n.t("AssignmentFailed"));
              }
            }
          }
          arr.push(item);
        });
        
        setServices([...arr]);
        if (hasErrors) setErrorAlert(true);
      })
      .catch((error) => {
        console.error("Error - postServicesAssignAdmin - ", error);
        setErrorAlertHeader(i18n.t("ServiceAlertError"));
        
        if (error.response?.data?.assigns?.some(a => a.reason === "Trip scheduled conflict")) {
          setErrorAlertMessage(i18n.t("OperatorAlreadyAssigned"));
        } else if (error.code === 500) {
          setErrorAlertMessage(i18n.t("ServerError"));
        } else {
          setErrorAlertMessage(i18n.t("AssignmentFailed"));
        }
        
        setErrorAlert(true);
      });
  };

  const onChangePlate = (service, e) => {
    const onServices = [...services];
    const onService = onServices.find((item) => item.code === service.code);

    onServices.splice(onServices.indexOf(onService), 1);
    onService.plate = e.value;
    onService.subDriver = e.sub;
    onService.nameDriver = e.sub;

    onServices.push(onService);
    onServices.sort((a, b) => a.code.localeCompare(b.code));
    setServices([...onServices]);
    onClickNextStep();
  };

  const setNewPlates = (updatedServices) => setServices(updatedServices);

  return (
    <Fragment>
      <CardBody>
        <AlertError
          showAlertError={errorAlert}
          setShowAlertError={setErrorAlert}
          textHeader={errorAlertHeader}
          textBody={errorAlertMessage}
        />
        <Row>
          <Col xxl={6} md={6} xs={12}>
            <h5>{i18n.t("RequestsToBeAssigned")}</h5>
            <p>{i18n.t("RequestsAssignedDesc")}</p>
            <h6>
              {i18n.t("RequestsAssignedDesc2", { number: services.length })}
            </h6>
          </Col>
          <div className="table-responsive pt-3 relative overflow-x-auto shadow-md sm:rounded-lg">
            <Table className="table table-responsive border table-assignment-services">
              <thead>
                <tr>
                  <th className="bg-light request-number-column">{i18n.t("ID")}</th>
                  <th className="bg-light origin-column">{i18n.t("Origin")}</th>
                  <th className="bg-light destination-column">{i18n.t("Destiny")}</th>
                  <th className="bg-light date-column">{i18n.t("Date")}</th>
                  <th className="bg-light hour-column">{i18n.t("Hour")}</th>
                  <th className="bg-light status-column">{i18n.t("Status")}</th>
                  <th className="bg-light plates-column">{i18n.t("Plate")}</th>
                </tr>
              </thead>
              {isLoading ? null : (
                <tbody>
                  {map(currentRecords, (item, key) => (
                    <tr key={key}>
                      <td>{item.code}</td>
                      <td>{item.origin.address.description}</td>
                      <td>{item.destination?.address?.description}</td>
                      <td>{item.scheduled_start.date}</td>
                      <td>{item.scheduled_start.time}</td>
                      <td>
                        {item.className !== undefined ? (
                          <p className={`${item.className}`}>{`${item.textContent}`}</p>
                        ) : (
                          <p className={`bg-${item.status.key.toLowerCase()} text-white rounded-2 text-center p-1 fs-10`}>
                            {`${item.status.value}`}
                          </p>
                        )}
                      </td>
                      <td>
                        <Card>
                          {item.className !== undefined ? (
                            <span
                              onClick={() => item.textContent === "No asignado" && handlePlateClick(item)}
                              style={{
                                textDecoration: "underline",
                                cursor: item.textContent === "No asignado" ? "pointer" : "not-allowed",
                              }}
                            >
                              {item.plate ? item.plate : i18n.t("Unassigned")}
                            </span>
                          ) : (
                            <span
                              onClick={() => handlePlateClick(item)}
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              {item.plate ? item.plate : i18n.t("Unassigned")}
                            </span>
                          )}
                        </Card>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              nPages > 1 && (
                <Paginations
                  perPageData={recordsPerPage}
                  data={services}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  isShowingPageLength={false}
                  paginationDiv="col-lg-12"
                  paginationClass="pagination pagination-rounded justify-content-center mt-3 mb-4 pb-1"
                />
              )
            )}
          </div>
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            <button
              onClick={() => onClickFinish()}
              disabled={!allAssigned}
              className="btn btn-users"
            >
              {i18n.t("Finished")}
            </button>
            <button
              onClick={() => history(-1)}
              className="btn btn-soft-secondary mx-2"
            >
              {i18n.t("Cancel")}
            </button>
          </Col>
        </Row>
      </CardBody>
      <ModalAssign
        isOpen={isModalOpen}
        toggle={toggleModal}
        status="OUT_OF_SERVICE"
        page={1}
        size={10}
        setNewPlates={setNewPlates}
        services={services}
        onChangePlate={onChangePlate}
        selectedService={selectedService}
      />
    </Fragment>
  );
};

export default Step1;
